import { Check } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";

// Reusable selectable card (source / strategy / etc.). Selected = cobalt ring.
export function SelectableCard({ selected, onClick, Icon, title, description, badge, disabled, testId, className }) {
  return (
    <button
      type="button"
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={cn(
        "group relative flex w-full items-start gap-3 rounded-lg border p-4 text-left transition-colors",
        selected ? "border-brand bg-brand/5" : "border-border bg-card hover:bg-accent/40",
        disabled && "cursor-not-allowed opacity-50",
        className,
      )}
      data-testid={testId}
    >
      {Icon && (
        <div className={cn(
          "flex h-9 w-9 shrink-0 items-center justify-center rounded-md border",
          selected ? "border-brand/30 bg-brand/10 text-brand" : "border-border bg-accent/40 text-foreground",
        )}>
          <Icon size={18} weight="duotone" />
        </div>
      )}
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <span className="truncate text-sm font-medium">{title}</span>
          {badge && (
            <span className="rounded-full border border-ai/30 bg-ai/10 px-1.5 py-px text-[9px] font-semibold uppercase tracking-wider text-ai">
              {badge}
            </span>
          )}
        </div>
        {description && <p className="mt-1 text-xs text-muted-foreground">{description}</p>}
      </div>
      {selected && (
        <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-brand text-brand-foreground">
          <Check size={12} weight="bold" />
        </span>
      )}
    </button>
  );
}
